<template>
  <b-row
    align-v="stretch"
    class="nothing"
  >
    <b-col align-self="center">
      <h2
        class="question-title with-subtext"
        :class="{'!tw-text-2xl sm:tw-px-10 md:!tw-text-[2rem]': isOnboardingRedesign && body.id === 'thankyou'}"
        v-html="body.title"
      >
      </h2>
      <p
        v-if="body.description"
        class="sub-text mb-0"
        :class="{
          'sub-text tw-text-lg': isOnboardingRedesign && !['notInterested', 'cancerRelated', 'over60'].includes(body.id),
          'question-title with-subtext !tw-text-xl md:!tw-text-2xl': isOnboardingRedesign && ['notInterested', 'cancerRelated', 'over60'].includes(body.id),
        }"
      >
        {{ body.description }}
      </p>
      <div
        v-if="body.image"
        class="image-holder"
      >
        <img
          :src="body.image"
          alt=""
        >
      </div>

      <OnboardingCTAContainer>
        <div
          class="tw-w-full tw-flex tw-gap-2"
          :class="isOnboardingRedesign && ['idphotoskip', 'personalphotoskip'].includes(body.id) ? 'tw-flex-col md:tw-flex-row tw-justify-center tw-items-center' : 'tw-flex-col'"
        >
          <template v-if="isOnboardingRedesign">
            <b-button
              v-if="['idphotoskip', 'personalphotoskip'].includes(body.id)"
              :class="{'tw-text-base tw-max-w-[350px] md:tw-text-lg lg:tw-max-w-[326px] xl:tw-max-w-[350px]': isOnboardingRedesign}"
              class="slight-rounded tw-max-w-[300px] tw-border-[#312849] tw-text-[#312849]"
              pill
              block
              variant="outline-info"
              :disabled="disabled || isSkipping"
              @click="skipUploading"
            >
              <b-spinner
                v-if="isSkipping"
                small
              />
              <template v-else>
                Skip Uploading
              </template>
            </b-button>
            <template v-if="['H', 'J', '1225-onboarding-core-v1', 'K'].includes(onboardingPatient?.flow_variant)">
              <b-button
                v-if="['under35', 'over60'].includes(body.id)"
                :class="{'tw-text-base tw-max-w-[350px] md:tw-text-lg lg:tw-max-w-[326px] xl:tw-max-w-[350px] 2xl:tw-max-w-[400px]': isOnboardingRedesign}"
                class="slight-rounded tw-max-w-[300px] tw-self-center tw-mt-0"
                pill
                block
                variant="info"
                :disabled="disabled || isSkipping"
                @click="submitAnswer"
              >
                See Treatments
              </b-button>
              <b-button
                v-else-if="['notInterested'].includes(body.id)"
                :class="{'tw-text-base tw-max-w-[350px] md:tw-text-lg lg:tw-max-w-[326px] xl:tw-max-w-[350px] 2xl:tw-max-w-[400px]': isOnboardingRedesign}"
                class="slight-rounded tw-max-w-[300px] tw-self-center tw-mt-0"
                pill
                block
                variant="info"
                :disabled="disabled || isSkipping"
                @click="submitAnswer"
              >
                Explore other offers
              </b-button>
              <b-button
                v-else-if="['under18'].includes(body.id)"
                :class="{'tw-text-base tw-max-w-[350px] md:tw-text-lg lg:tw-max-w-[326px] xl:tw-max-w-[350px] 2xl:tw-max-w-[400px]': isOnboardingRedesign}"
                class="slight-rounded tw-max-w-[300px] tw-self-center tw-mt-0"
                pill
                block
                variant="info"
                :disabled="disabled || isSkipping"
                @click="goToHomepage"
              >
                Go to Winona's homepage
              </b-button>
              <b-button
                v-else
                :class="{'tw-text-base tw-max-w-[350px] md:tw-text-lg lg:tw-max-w-[326px] xl:tw-max-w-[350px] 2xl:tw-max-w-[400px]': isOnboardingRedesign}"
                class="slight-rounded tw-max-w-[300px] tw-self-center tw-mt-0"
                pill
                block
                variant="info"
                :disabled="disabled || isSkipping"
                @click="submitAnswer"
              >
                {{ ['thankyou', 'male', 2.44, 'cancerRelated'].includes(body.id) || body.type === 'exit' ? 'Explore other options' : 'Continue' }}
              </b-button>
            </template>
            <b-button
              v-else
              :class="{'tw-text-base tw-max-w-[350px] md:tw-text-lg lg:tw-max-w-[326px] xl:tw-max-w-[350px] 2xl:tw-max-w-[400px]': isOnboardingRedesign}"
              class="slight-rounded tw-max-w-[300px] tw-self-center tw-mt-0"
              pill
              block
              variant="info"
              :disabled="disabled || isSkipping"
              @click="submitAnswer"
            >
              {{ ['thankyou', 'male', 2.44, 'under35', "over60"].includes(body.id) || body.type === 'exit' ? 'Explore other options' : 'Continue' }}
            </b-button>
          </template>
          <template v-else>
            <b-button
              class="slight-rounded"
              pill
              block
              variant="info"
              :disabled="disabled"
              @click="submitAnswer"
            >
              Continue
            </b-button>
          </template>
        </div>
      </OnboardingCTAContainer>
    </b-col>
  </b-row>
</template>

<script>
import { mapState } from 'vuex'
// components
import OnboardingCTAContainer from '@/components/onboarding/OnboardingCTAContainer.vue';
import { AuthService } from '@/services/auth.service';

export default {
  components: {
    OnboardingCTAContainer,
  },
  props: {
    body: {
      type: Object,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    isSkipping: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState('global', ['isOnboardingRedesign']),
    ...mapState('onboarding', ['onboardingPatient']),
  },
  methods: {
    submitAnswer() {
      this.$emit('submitAnswer', this.body.id, '');
    },
    async goToHomepage() {
      await AuthService.logout();
      if (process.env.VUE_APP_SERVER === 'production') {
        window.location.href = 'https://bywinona.com';
      } else {
        window.location.href = 'https://staging-nuxt3.bywinona.com';
      }
    },
    skipUploading() {
      this.$emit('skip');
    }
  },
};
</script>

<style lang="scss" scoped>
.image-holder {
  height: 350px;
  margin-bottom: 1rem;

  img {
    object-fit: cover;
    width: 100%;
    height: 100%;
  }
}
</style>
